import fileSaver from "file-saver";
import { Box, CircularProgress, Icon, Paper, Typography } from "@mui/material";
import {
    useBaseAppContext,
    dateFormatLocale,
} from "@programari-limit/base-react";
import useRequest from "hooks/useInformesRequest";
import React from "react";
import { useTranslation } from "react-i18next";
import LoadingButton from "@mui/lab/LoadingButton";

const Versio = () => {
    const { setContentExpandsToAvailableHeight } = useBaseAppContext();
    const { currentLanguage } = useBaseAppContext();
    const { t } = useTranslation();
    const { getVersioPropietats, getDeclaracioResponsable } = useRequest();
    const [loading, setLoading] = React.useState(true);
    const [loadingDeclaracio, setLoadingDeclaracio] = React.useState(false);
    const [propietats, setPropietats] = React.useState();

    const getPropietats = () => {
        setLoading(true);
        getVersioPropietats().then((result) => {
            setPropietats(result?.data);
            setLoading(false);
        });
    };
    const getDeclaracio = () => {
        setLoadingDeclaracio(true);
        getDeclaracioResponsable().then((response) => {
            const fileName =
                currentLanguage === "ca"
                    ? "declaracio_responsable.pdf"
                    : "declaración_responsable.pdf";
            const responseData = response.data;
            if (
                typeof responseData === "string" ||
                responseData instanceof String
            ) {
                const contentType = response.headers?.get("Content-Type");
                fileSaver(
                    new Blob([responseData], { type: contentType }),
                    fileName,
                );
                setLoadingDeclaracio(false);
            } else {
                fileSaver(response.data, fileName);
                setLoadingDeclaracio(false);
            }
        });
    };

    React.useEffect(() => {
        getPropietats();
    }, []);

    //TODO. Aquest useEffect es fa per solucionar un problema de la llibreria, dins GridCore L.723-729
    React.useEffect(() => {
        setContentExpandsToAvailableHeight(true);
        return () => setContentExpandsToAvailableHeight(false);
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    mb: 14,
                    p: 4,
                    borderRadius: 2,
                    maxWidth: 500,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ textAlign: "center" }}
                >
                    {t("versio.title")}
                </Typography>
                {propietats && !loading ? (
                    <>
                        <Typography gutterBottom sx={{ mb: 2 }}>
                            {t("versio.subTitle")}
                        </Typography>
                        <Typography gutterBottom sx={{ fontWeight: "bold" }}>
                            {t("versio.nom")}:&nbsp;
                            <Typography
                                component={"span"}
                                sx={{ fontStyle: "italic" }}
                            >
                                {propietats?.appName}
                            </Typography>
                        </Typography>
                        <Typography gutterBottom sx={{ fontWeight: "bold" }}>
                            {t("versio.versio")}:&nbsp;
                            <Typography
                                component={"span"}
                                sx={{ fontStyle: "italic" }}
                            >
                                {propietats?.appVersion}
                            </Typography>
                        </Typography>
                        <Typography gutterBottom sx={{ fontWeight: "bold" }}>
                            {t("versio.data")}:&nbsp;
                            <Typography
                                component={"span"}
                                sx={{ fontStyle: "italic" }}
                            >
                                {dateFormatLocale(propietats?.appDate)}
                            </Typography>
                        </Typography>

                        <LoadingButton
                            onClick={getDeclaracio}
                            loading={loadingDeclaracio}
                            loadingPosition="end"
                            startIcon={<Icon>description</Icon>}
                            variant="outlined"
                            sx={{ mt: 2 }}
                        >
                            {t("versio.declaracioResponsable")}
                        </LoadingButton>
                    </>
                ) : (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <CircularProgress />
                    </Box>
                )}
            </Paper>
        </Box>
    );
};

export default Versio;
